<!--
  ~ Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
  ~ Unauthorised copying of this file, via any medium is strictly prohibited
  ~ Proprietary and confidential
  ~ Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
  ~
  -->

<acabim-card cardHeading="{{heading}}" [isCollapsible]="false" [cardContent]="requestTrial"></acabim-card>

<ng-template #requestTrial>
    <form [formGroup]="addSeatForm" class="m-1">
        <div class="p-fluid p-formgrid cas-flex-row">
            <div class="p-field p-col-12 p-md-4">
                <label for="num-of-seats">Number of Seats</label>
                <p-inputNumber id="num-of-seats" pInputText formControlName="numberOfSeats" [showButtons]="true" [min]="1"></p-inputNumber>
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label for="restricted-solution">Restricted Solution <span class="text-muted">(Optional)</span></label>
                <p-dropdown id="restricted-solution" inputId="restricted-solution" [options]="currentSolutions" formControlName="restrictedSolution"
                            optionLabel="name"></p-dropdown>
            </div>
            <div class="p-field p-col-12 p-md-4">
                <label for="restricted-role">Restricted Role <span class="text-muted">(Optional)</span></label>
                <p-dropdown id="restricted-role" inputId="restricted-role" [options]="currentRoles" formControlName="restrictedRole"
                            optionLabel="name"></p-dropdown>
            </div>
        </div>
        <button (click)='requestTrialSeats()' class="cas-button-action mb-4">{{requestButtonText}}</button>
    </form>
</ng-template>

<p-toast position="top-right" key="add-organisation-seat-component"></p-toast>
